require('./store'); 
require('./info');
require('./payment');
require('./delivery/index');
require('./mail');
require('./confirm');
require('./finish');
